<template>

    <button
      class="portfolioCategory"
      :ref="`portfolioCategory${item.num}`"
      :style="{background :
         (activeState ?
          `url(//${item.savedUrl}portfolio/active/${item.portfolioActiveImage}) 0% 0% / contain no-repeat `
           : `url(//${item.savedUrl}portfolio/${item.portfolioImage}) 0% 0% / contain no-repeat ` ),
      }"
      @mouseenter="handleCategoryMouseEnter(item.num)"
      @mouseleave="handleCategoryMouseLeave(item.num)"
      @click="handleCategoryClick(item.num)"
    />

</template>

<script>
    import {bus} from '@/bus/event'
    import {mapGetters , mapState} from 'vuex'

    export default {
        name: "category" ,
        props: ['item' , 'all-active'] ,
        computed : {
          ...mapGetters({
            isCategoryByAllNumber : 'categoryStore/getCategoryByAll' ,
            activeCategory : 'categoryStore/getActiveCategory' ,
          })
        },
        data () {
          return {
            activeState : false ,
            isAll : null ,
          }
        },
        beforeUpdate () {

        },
        watch : {
          activeCategory () {
            //console.log(this.item.num , 'dfdfdfdfdfdfdf');
            this.activeState = this.activeCategory.find(n => n === this.item.num) !== undefined;

          }
        },
        updated () {
          //console.log('!!!!child updated!!!')
          //this.activeState = this.activeCategory.find(n => n === this.item.num) !== undefined;
        },
        created () {
          //console.log(this.activeCategory.find(n => n === this.item.num) !== undefined);
          this.activeState = this.activeCategory.find(n => n === this.item.num) !== undefined;
          this.isAll = this.isCategoryByAllNumber === this.item.num;
          //this.activeState = this.item.num === this.isCategoryByAllNumber;
        },
        methods : {
          handleCategoryMouseEnter ( elmKey ) {

            if(!( navigator.userAgent.match(/Android/i)
              || navigator.userAgent.match(/webOS/i)
              || navigator.userAgent.match(/iPhone/i)
              || navigator.userAgent.match(/iPad/i)
              || navigator.userAgent.match(/iPod/i)
              || navigator.userAgent.match(/BlackBerry/i)
              || navigator.userAgent.match(/Windows Phone/i)
              )){
              const {item} =  this;
              this.$refs[`portfolioCategory${elmKey}`].style.background =
                `url(//${item.savedUrl}portfolio/active/${item.portfolioActiveImage}) 0% 0% / contain no-repeat`
            }

          },
          handleCategoryMouseLeave ( elmKey ) {
            const {item} =  this;
            if(!this.activeState) {
              this.$refs[`portfolioCategory${elmKey}`].style.background =
                `url(//${item.savedUrl}portfolio/${item.portfolioImage}) 0% 0% / contain no-repeat`
            }
          },
          handleCategoryClick ( elmKey ) {
            this.$store.commit('categoryStore/setActiveCategory',
              {activeCategory: elmKey}
            );
            this.activeState = !this.activeState;



            //ON -> OFF 끌때 isOn OFF -> ON !isOn
            const isOn = this.activeCategory.find(n => n === elmKey) !== undefined;

            if(this.isAll){ //전체보기 클릭
              //console.log(isOn);
              // this.activeCategory.find(n => n === elmKey) === undefined //
                this.$store.commit('categoryStore/setIsAllActive' ,
                  {actually : isOn}
                );
            }
            else{  //전체보기 외 클릭
              if(isOn) {
                this.$store.commit('categoryStore/setIsAllActive' ,
                  {actually : false}
                );

                if(this.allActive)
                  this.$store.commit('categoryStore/setRemovedByAllItem');


              }
              else{
                //console.log('OFF!')
              }

            }




          },

        },
    }
</script>

<style scoped lang="scss">
  @import "@/styles/Portfolio.scss";
</style>



// WEBPACK FOOTER //
// src/components/menu/Portfolio/Category.vue